define('main_page',['backbone'], function (Backbone) {

	/*
	 * Vista base para dibujar el contenido 
	 *  principal (loop, single, page and error).
	**/
	return Backbone.View.extend({

		  view : false

		, initialize: function (opts) {
			this.opts = opts || {};
			this.view = this.opts.view;
		}

		// , get_type : function get_type() {

		// 	console.log(this.opts);

		// }

		, render : function render(ele) {
			// console.log('eele lulzies');
			// console.log(ele);
			// console.log(this.opts.tmpl);
			// console.log('OPTS->');
			// console.log(this.$el);
			// console.log('html '+this.view(this.opts.data));
			// console.log(this.view);
			// console.log('data: ');
			// console.log(this.opts.data);
			// this.$el.html(Mustache.render(this.opts.tmpl, this.opts.content)).promise().done(function() {
			return this.$el.html(this.view(this.opts.data)).promise().done(function() {
				// console.log('HTML Rendered');
				// console.log(ele);
				ele();
			});
			// this.$el.html(tpl['acerca-de'](this.opts.content)).promise().done(function() {
				// console.log('HTML Rendered');
				// console.log(ele);
				// ele();
			// });
			// console.log(this.opts);
			// // console.log('Render this.opts.tmpl: '+this.opts.tmpl);
			// console.log('Render id: '+this.$el.attr('id'));
			// console.log('Render class: '+this.$el.attr('class'));

		}

	});

});
